import { useContext, memo } from 'react';
import type { CSSProperties, ReactNode } from 'react';

import styles from './SimplifiedCharts.module.css';
import GaugeChart from 'react-gauge-chart';
import { isBrowser } from 'react-device-detect';

import { AllInputDataContext } from '../../../../config';

type SimplifiedChartView = {
  img: { src: string; width?: string | number };
  realsticValue: ReactNode;
  percentage: number;
  actualValue: string | number;
};

type SimplifiedChartsTopProps = {
  guageChartID: number;
  name: string;
  simpleData: SimplifiedChartView;
  style?: CSSProperties;
};

const SimplifiedChartsTop = memo(
  ({ guageChartID, name, simpleData }: SimplifiedChartsTopProps) => {
    const { simplifiedData } = useContext(AllInputDataContext);

    return (
      <div className={styles.simplifiedChartTop}>
        <h1>{name.charAt(0).toUpperCase() + name.slice(1)}</h1>
        <div className={styles.imgContainer}>
          <img
            src={simpleData.img.src}
            alt='line drawing of a house'
            width={simpleData.img.width}
          />
        </div>
        <h3>{simpleData.realsticValue}</h3>
        <p>{simplifiedData[name].realityDescription}</p>

        <GaugeChart
          animate={false}
          className={styles.guageChartContainer}
          id={'chart' + guageChartID}
          marginInPercent={0.02}
          nrOfLevels={20}
          percent={simpleData.percentage}
          // `actualValue` is always a string at runtime.
          formatTextValue={() => simpleData.actualValue as string}
          textColor={'rgba(255,255,255,0.88)'}
        />

        <p style={isBrowser ? { fontWeight: 'bold' } : {}}>
          {simplifiedData[name].guageTitle}
        </p>
      </div>
    );
  }
);

type SimplifiedChartsBottomProps = {
  name: string;
  simpleData: { alertLevel: number };
  style?: CSSProperties;
};

const SimplifiedChartsBottom = memo(
  ({ name, simpleData }: SimplifiedChartsBottomProps) => {
    const { simplifiedData, optionsData } = useContext(AllInputDataContext);

    return (
      <div
        className={styles.simplifiedChartBottom}
        style={{
          backgroundColor: optionsData[`alertLevel${simpleData.alertLevel}`]
        }}
      >
        <p>{simplifiedData[name][`alertLevel${simpleData.alertLevel}`]}</p>
      </div>
    );
  }
);

export { SimplifiedChartsTop, SimplifiedChartsBottom };
